import React, {useEffect, useMemo, useState} from 'react';
import {Button, Input, Loader, ModalRequest, Select} from "../common";
import {ALERT_TYPES, BUTTON_TYPES, IFormFields, IProductsList, IUser, MODAL_STEPS} from "../../types";
import {FinishRegistrationModal, WarningModal} from "./index";
import FormWaitingModal from "./FormWaitingModal";
import {useMutation, useQuery} from "react-query";
import {ReqFirstStep, ReqSecondStep} from "../ui";
import {useAlert} from "../common/Alert";

const CreateRequestModal = (
  { open, onClose, isProduct = false, productID = '' }:
  { open: boolean; onClose: () => void; isProduct?: boolean; productID?: string | number }
) => {
  const { setAlert } = useAlert();

  const { data: productFields }: { data: any | undefined } = useQuery(["productsFormFields", productID], {
    refetchOnWindowFocus: false,
    enabled: isProduct && !!productID
  })
  const { data }: { data: IUser | undefined; } = useQuery(["userInfo"], { refetchOnWindowFocus: false });
  const { data: products, isLoading }:
    {
      data: IProductsList | undefined;
      isLoading: boolean
    } = useQuery(["productFormList"], { refetchOnWindowFocus: false });
  const getFormFields = useMutation(["getFormFields"], {
    onMutate: (data: { bank: string | number; type: string }) => {},
    onSuccess: ({ data }) => {
      setSteps(MODAL_STEPS.FIELDS);
      setFieldData(data);
    },
    onError: (e: any) => {
      setAlert(`${Object.values(e.response.data).flat(2)[0]}`, ALERT_TYPES.ERROR);
    }
  });
  const onSubmitForm = useMutation(["submitForm"], {
    onMutate: (data: { data: { data: Array<{ name: string; value: string }> }, id: string | number }) => {},
    onSuccess: () => {
      onClose();
      setSteps(MODAL_STEPS.CHOOSE_BANK_AND_PRODUCT);
      setAlert('Заявка успешно создана!', ALERT_TYPES.SUCCESS);
    },
    onError: (e: any) => {
      onClose();
      setSteps(MODAL_STEPS.CHOOSE_BANK_AND_PRODUCT);
      setAlert(`${Object.values(e.response.data).flat(2)[0]}`, ALERT_TYPES.ERROR);
    }
  })

  const [fieldData, setFieldData] = useState<IFormFields | null>(null);
  const [isOpenWarningModal, setIsOpenWarningModal] = useState<boolean>(false);
  const [openRegistrationModal, setOpenRegistrationModal] = useState<boolean>(false);
  const [openWaitingModal, setOpenWaitingModal] = useState<boolean>(false);
  const [steps, setSteps] = useState<string>(MODAL_STEPS.CHOOSE_BANK_AND_PRODUCT);
  const onCloseWarningModal = () => setIsOpenWarningModal(false);

  const handleCloseModal = () => {
    setOpenRegistrationModal(false)
    setOpenWaitingModal(false);
  }

  useEffect(() => {
    if (!data?.is_agent && !data?.form) {
      setOpenRegistrationModal(open)
    } else if (!data?.is_agent && data?.form) {
      setOpenWaitingModal(open)
    }
  }, [open])

  if (!data?.is_agent && !data?.form) {
    return <FinishRegistrationModal open={openRegistrationModal} onClose={handleCloseModal} />;
  }

  if (!data?.is_agent && data?.form) {
    return <FormWaitingModal open={openWaitingModal} onClose={handleCloseModal} />;
  }

  if (isLoading) {
    return <Loader />
  }
  const handleChangeStep = (step: string | null, data?: any) => {
    step && setSteps(step);
    data && getFormFields.mutate(data);
  };

  const submitForm = async (data: any) => {
    if (fieldData?.product_id) {
      await onSubmitForm.mutate({ data, id: fieldData?.product_id })
    } else if (isProduct && productID) {
      await onSubmitForm.mutate({ data, id: productID });
    }
  }

  const handleClearFormAndClose = () => {
    setSteps(MODAL_STEPS.CHOOSE_BANK_AND_PRODUCT);
    setFieldData(null);
    onClose();
  }

  return (
    <ModalRequest open={open} onClose={() => setIsOpenWarningModal(true)} title="Создать заявку">
      <>
        <WarningModal
          open={isOpenWarningModal}
          onClose={handleClearFormAndClose}
          onCloseWarningModal={onCloseWarningModal}
        />
        {
          !isProduct && steps === MODAL_STEPS.CHOOSE_BANK_AND_PRODUCT
          ? <ReqFirstStep
              data={products}
              onClose={onClose}
              handleChangeStep={handleChangeStep}
            />
          : <ReqSecondStep
              data={isProduct ? productFields : fieldData}
              onClose={onClose}
              isProduct={isProduct}
              handleChangeStep={handleChangeStep}
              onSubmit={submitForm}
            />
        }
      </>
    </ModalRequest>
  )
};

export default CreateRequestModal;
